module.exports = __webpack_public_path__ + "fonts/Flaticon2.eafcbac0.ttf";